import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Typography,
} from "@mui/material";
import React, { useContext } from "react";
import { NavigationMenuContext } from '../../../store/side-menu-navigation-context';
import { getAccordionTitleClassName } from "../../../utils/helperFunctions";
import { menuData } from "./MenuData";
import "./SideMenu.scss";
export interface MenuItem {
  title: string;
  items?: MenuItem[];
  color?: string;
  path?: string;
}

const RecursiveAccordion: React.FC<{
  menu: MenuItem;
  items: MenuItem[];
  expanded: { [key: string]: string | false };
  handleChange: (level: string, panel: string) => void;
  level: string;
  onClick: (item: MenuItem) => void;
  activeItem: { item: MenuItem } | undefined;
  breadCrumbConfig: string[];
}> = ({ items, expanded, handleChange, level, onClick, activeItem, menu, breadCrumbConfig }) => {

  const onMenuClick = (menu: MenuItem, index?: number) => {
    onClick(menu);
  };

  return (
    <List disablePadding className={`${level === 'root' ? 'list' : ''}`}>
      {items.map((item, index) => {
        const panelId = `${level}-${item.title}`;
        item.title === 'REST APIs' && console.log(panelId)
        return (
          <ListItem key={index} disablePadding>
            {item.items ? (
              <Accordion
                elevation={0}
                className="accordion"
                expanded={expanded[level] === panelId}
                onChange={() => handleChange(level, panelId)}
              >
                <AccordionSummary
                  expandIcon={
                    <ArrowForwardIosSharpIcon sx={{ fontSize: "0.9rem", marginRight: '8px' }} />
                  }
                  className="accordion-summary"
                >
                  <Typography
                    className={getAccordionTitleClassName(level, panelId)}
                    style={{ fontWeight: breadCrumbConfig.includes(item.title) && panelId.includes(breadCrumbConfig[0]) ? 700 : 'normal' }}
                  >
                    {item.title}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails className="accordion-details">
                  <RecursiveAccordion
                    items={item.items}
                    menu={menu}
                    expanded={expanded}
                    handleChange={handleChange}
                    onClick={onMenuClick}
                    level={`${level}-${item.title}`}
                    activeItem={activeItem}
                    breadCrumbConfig={breadCrumbConfig}
                  />
                </AccordionDetails>
              </Accordion>
            ) : (
              <ListItemButton
                className={`list-item-button ${activeItem?.item?.title === item.title && activeItem?.item?.path === item.path ? 'active-list-item-button' : ''}`}
                onClick={(event) => onMenuClick(item, index)}
              >
                <ListItemText
                  primary={
                    <Typography
                      className={`list-item-text  
                      ${getAccordionTitleClassName(level, panelId)}`}
                    >
                      {item.title.startsWith("GET") ||
                        item.title.startsWith("PUT") ||
                        item.title.startsWith("POST") ||
                        item.title.startsWith("DEL") ? (
                        <>
                          <span
                            className="method-word"
                            style={{ color: item.color || "inherit" }}
                          >
                            {item.title.split(" ")[0]}
                          </span>
                          <span className="method-description" title={item.title.split(" ").slice(1).join(" ")}>
                            {item.title.split(" ").slice(1).join(" ")}
                          </span>
                        </>
                      ) : (
                        item.title
                      )}
                    </Typography>
                  }
                />
              </ListItemButton>
            )}
          </ListItem>
        );
      })}
    </List>
  );
};

interface SideMenuProps {
  onMenuClick: (item: MenuItem) => void;
  activeItem: { item: MenuItem } | undefined;
  menu: MenuItem;
  breadCrumbConfig: string[];
}

const SideMenu: React.FC<SideMenuProps> = (props) => {
  const { expanded, handleNavigationChange } = useContext(NavigationMenuContext);

  const handleChange = (level: string, panel: string) => {
    handleNavigationChange(level, panel);
  };

  const onMenuClick = (item: MenuItem) => {
    props.onMenuClick(item);
  };

  return (
    <div className="side-menu">
      <RecursiveAccordion
        onClick={onMenuClick}
        items={menuData}
        menu={props.menu}
        expanded={expanded}
        handleChange={handleChange}
        level="root"
        activeItem={props.activeItem}
        breadCrumbConfig={props.breadCrumbConfig}
      />
    </div>
  );
};

export default SideMenu;